import { render } from "./CustomDomains.vue?vue&type=template&id=66f4171a&scoped=true"
import script from "./CustomDomains.vue?vue&type=script&lang=js"
export * from "./CustomDomains.vue?vue&type=script&lang=js"

import "./CustomDomains.vue?vue&type=style&index=0&id=66f4171a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-66f4171a"

export default script